export function debounce<T extends (...args: any[]) => any>(
	func: T,
	wait: number
): (...args: Parameters<T>) => void {
	let timeout: ReturnType<typeof setTimeout> | null = null
	return (...args: Parameters<T>) => {
		if (timeout !== null) {
			clearTimeout(timeout)
		}
		timeout = setTimeout(() => func(...args), wait)
	}
}
